// Головна сторінка — каруселі FancyBox

window.addEventListener("load", function () {
  // hero slider
  const container = document.getElementById("fbox__hero");
  if (container) {
    new Carousel(container, {
      Dots: false,
      Thumbs: { type: "classic" },
      center: false,
      infinite: true,
      Autoplay: { timeout: 5000, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Акції
  const container2 = document.getElementById("fbox__aktcii");
  if (container2) {
    new Carousel(container2, {
      Dots: false,
      Thumbs: { type: "classic" },
      center: false,
      infinite: true,
      Autoplay: { timeout: 5000, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Партнери (також на /catalog)
  const container3 = document.getElementById("partners");
  if (container3) {
    new Carousel(container3, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 10,
      center: false,
      infinite: true,
      Autoplay: { timeout: 4000, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Лідери продажу
  const container4 = document.getElementById("bestsellers");
  if (container4) {
    new Carousel(container4, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 10,
      center: false,
      infinite: true,
      Autoplay: { timeout: 4500, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  const container8 = document.getElementById("bestsellers2");
  if (container8) {
    new Carousel(container8, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 10,
      center: false,
      infinite: true,
      Autoplay: { timeout: 4500, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Новинки магазину
  const container7 = document.getElementById("new-prods");
  if (container7) {
    new Carousel(container7, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 10,
      center: false,
      infinite: true,
      Autoplay: { timeout: 4500, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Новини
  const container5 = document.getElementById("news-tsrs");
  if (container5) {
    new Carousel(container5, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 10,
      center: false,
      infinite: true,
      Autoplay: { timeout: 4200, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Про нас
  const container6 = document.getElementById("block-about-imgs");
  if (container6) {
    new Carousel(
      container6,
      {
        Dots: false,
        Thumbs: { type: "classic" },
        slidesPerPage: 10,
        center: false,
        infinite: true,
        Autoplay: { timeout: 4000, pauseOnHover: false },
        l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
      },
      { Autoplay },
    );
  }
});
